import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrivateComponent } from '../private.component';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
})
export class NotFoundComponent implements OnInit {
  parentId: boolean;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.parentId = this.route.parent.snapshot.params.id
      ? this.route.parent.snapshot.params.id
      : false;
  }
}
